import type { NumericFormat } from '../hooks/useColumnConfig';

/** A cell value as a number, or null when it is blank. The API sends some numbers as strings. */
export function toNumber(value: unknown): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string' && value.trim() !== '') {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

/** MDF-41: the mean of the values that are not blank, or null when all are blank. A blank never counts as 0. */
export function averageOf(values: unknown[]): number | null {
  const numbers = values.map(toNumber).filter((n): n is number => n !== null);
  if (numbers.length === 0) return null;
  return numbers.reduce((sum, n) => sum + n, 0) / numbers.length;
}

/** MDF-41: an average in its column's number format, or '-' when there is no value. */
export function formatAverage(value: number | null | undefined, format: NumericFormat): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '-';
  return format === 'percent' ? `${Math.round(value)}%` : value.toFixed(1);
}
